const KEY = "profile_completion_return";
const MAX_AGE = 24 * 60 * 60 * 1000;

// Survive onboarding's intermediate routes and refreshes, within this tab only.
export function rememberCompletionReturn(userId, state) {
  try {
    sessionStorage.removeItem(KEY);
    if (!userId || (!state?.dogData && !state?.pId)) return;
    sessionStorage.setItem(KEY, JSON.stringify({ userId: String(userId), state, at: Date.now() }));
  } catch {
    // Storage restrictions must not prevent profile completion.
  }
}

export function takeCompletionReturn(userId) {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY));
    sessionStorage.removeItem(KEY);
    if (saved?.userId !== String(userId) || Date.now() - saved.at > MAX_AGE) return null;
    return saved.state?.dogData || saved.state?.pId ? saved.state : null;
  } catch {
    return null;
  }
}
